var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7468_144831)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7468_144831)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7468_144831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 13.5C3.375 14.8296 3.63689 16.1462 4.14572 17.3747C4.65455 18.6031 5.40035 19.7193 6.34054 20.6595C7.28074 21.5996 8.39691 22.3455 9.62533 22.8543C10.8538 23.3631 12.1704 23.625 13.5 23.625C14.8296 23.625 16.1462 23.3631 17.3747 22.8543C18.6031 22.3455 19.7193 21.5996 20.6595 20.6595C21.5996 19.7193 22.3455 18.6031 22.8543 17.3747C23.3631 16.1462 23.625 14.8296 23.625 13.5C23.625 12.1704 23.3631 10.8538 22.8543 9.62533C22.3455 8.39691 21.5996 7.28074 20.6595 6.34054C19.7193 5.40035 18.6031 4.65455 17.3747 4.14572C16.1462 3.63689 14.8296 3.375 13.5 3.375C12.1704 3.375 10.8538 3.63689 9.62533 4.14572C8.39691 4.65455 7.28074 5.40035 6.34054 6.34054C5.40035 7.28074 4.65455 8.39691 4.14572 9.62533C3.63689 10.8538 3.375 12.1704 3.375 13.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.125H10.1363",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 10.125H16.8863",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.625C9 15.8185 9.47411 16.9631 10.318 17.807C11.1619 18.6509 12.3065 19.125 13.5 19.125C14.6935 19.125 15.8381 18.6509 16.682 17.807C17.5259 16.9631 18 15.8185 18 14.625H9Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7468_144831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7468_144831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7468_144831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodHappy);
export default __webpack_public_path__ + "static/media/mood-happy.69ebab6d34235f0d666c64296e6706fb.svg";
export { ForwardRef as ReactComponent };